import { Controller } from "@hotwired/stimulus"

// On the bulk form of an expense's Belegpositionen (Expenses::ItemsGridComponent): each control names
// a field (`data-field`) and the value to set — a picked option, or the button's `data-value` —
// and applying it fills the form's two hidden fields and submits. The selected lines' checkboxes
// belong to the form through their `form` attribute.
export default class extends Controller {
  static targets = ["field", "value"]

  apply(event) {
    const control = event.currentTarget
    const value = control.tagName === "SELECT" ? control.value : control.dataset.value
    // The blank option is the placeholder, not a choice; and without a ticked line there is
    // nothing to apply it to (the lines' checkboxes count among the form's elements).
    if (control.tagName === "SELECT" && value === "") return
    if (!this.selectionMade) return

    this.fieldTarget.value = control.dataset.field
    this.valueTarget.value = value
    this.element.requestSubmit()
  }

  get selectionMade() {
    return [...this.element.elements].some((input) => input.name === "item_ids[]" && input.checked)
  }
}
